import { createGlobalState } from "react-hooks-global-state";

const initialState = {
  cursorVariant: "default",
};
const { useGlobalState } = createGlobalState(initialState);

export default useGlobalState;
